
<mat-menu #admin="matMenu">
  <div mat-menu-item routerLink="/admin/menubuilder" skipLocationChange>Build Menu</div>
  <div mat-menu-item routerLink="/admin/openinghours" skipLocationChange>Opening hours</div>
  <div mat-menu-item routerLink="/admin/topbannertext" skipLocationChange>Banner Text</div>
  <div mat-menu-item routerLink="/admin/vieworder" skipLocationChange>View Orders</div>
  <div mat-menu-item routerLink="/home" skipLocationChange>View Members</div>
</mat-menu>

<div class="wrapper" style="background-color: green;">

  <div id="content" >

    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="navbar-toggler" id="sidebarCollapse"
        (click)="isSidebarOpen=!isSidebarOpen" (keyup.enter)="isSidebarOpen=!isSidebarOpen" tabindex="0" role="button" style="margin-left:0px; cursor: pointer;">
        <span class="navbar-toggler-icon">
          <i class="fas fa-bars" style="color: honeydew;"></i>
        </span>
      </div>
      <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
        <a class="navbar-brand" routerLink="/home"  skipLocationChange><img src="https://appdeveloperenv.blob.core.windows.net/assets/bddinelogo1.png" alt="BD Dine logo" style="width: 47px;height: 23px;"></a>
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
          <li class="nav-item"><a class="nav-link" routerLink="/home"  skipLocationChange>Home</a></li>
          <li class="nav-item"><a class="nav-link"  (click)="goToMenu()" (keyup.enter)="goToMenu()" tabindex="0" style="cursor: pointer;">Menu</a></li>
          <li class="nav-item"><a (click)="goToYoello()" (keyup.enter)="goToYoello()" tabindex="0" class="nav-link" style="cursor: pointer;">Order
          and pay</a></li>
          @if (isAdminLoggedIn) {
            <li class="nav-item"><a class="nav-link" [matMenuTriggerFor]="admin" style="cursor: pointer;">Admin</a></li>
          }
          @if (!isAdminLoggedIn && !isUserLoggedIn) {
            <li class="nav-item"><a class="nav-link"  routerLink="/login"  skipLocationChange>Member</a></li>
          }
          @if (isUserLoggedIn) {
            <li class="nav-item"><a class="nav-link"  routerLink="/member/home"  skipLocationChange>Member</a></li>
          }
          @if (isUserLoggedIn || isAdminLoggedIn) {
            <li class="nav-item"><a class="nav-link"  routerLink="/"  skipLocationChange><span (click)="logout()" (keyup.enter)="logout()" tabindex="0" role="button">Logout</span></a></li>
          }
          <li class="nav-item"><a class="nav-link"  routerLink="/contact/contactus"  style="cursor: pointer;" skipLocationChange ><span (click)="goToContactUs()" (keyup.enter)="goToContactUs()" tabindex="0" role="button">Contact us</span></a></li>
        </ul>
      </div>
    </nav>
  </div>
  @if (isSidebarOpen) {
    <nav id="sidebar" (click)="isSidebarOpen=!isSidebarOpen" (keyup.enter)="isSidebarOpen=!isSidebarOpen" tabindex="0" role="button">
      <div class="sidebar-header">
        <img src="https://appdeveloperenv.blob.core.windows.net/assets/bddinelogo1.png" alt="BD Dine logo" style="width: 47px;height: 23px;">
        <span style="padding-left: 232px;"><i class="fas fa-times" style="color: gray;"></i> </span>
      </div>
      <ul class="list-unstyled components">
        <li class="active">
          <a routerLink="/home" skipLocationChange data-toggle="collapse" aria-expanded="false">Home</a>
        </li>
        <li class="active">
          <a (click)="goToYoello()" (keyup.enter)="goToYoello()" tabindex="0" aria-expanded="false" data-toggle="collapse">Order and pay</a>
        </li>
        <li class="active">
          <a (click)="goToMenu()" (keyup.enter)="goToMenu()" tabindex="0" skipLocationChange data-toggle="collapse" aria-expanded="false">Menu</a>
        </li>
        @if (isAdminLoggedIn) {
          <li class="active">
            <a aria-expanded="false" data-toggle="collapse" routerLink="/admin/menubuilder" skipLocationChange>Build
            Menu</a>
          </li>
        }
        @if (isAdminLoggedIn) {
          <li class="active">
            <a aria-expanded="false" data-toggle="collapse" routerLink="/admin/openinghours" skipLocationChange>Opening
            Hours</a>
          </li>
        }
        @if (isAdminLoggedIn) {
          <li class="active">
            <a aria-expanded="false" data-toggle="collapse" routerLink="/admin/topbannertext"
            skipLocationChange>Banner Text</a>
          </li>
        }
        @if (isAdminLoggedIn) {
          <li class="active">
            <a aria-expanded="false" data-toggle="collapse" routerLink="/admin/vieworder"
              skipLocationChange><span (click)="goToMenu()" (keyup.enter)="goToMenu()" tabindex="0" role="button">View orders</span></a>
            </li>
          }
          @if (!isAdminLoggedIn && !isUserLoggedIn) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/login" skipLocationChange>Member</a>
            </li>
          }
          @if (isUserLoggedIn) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/member/home" skipLocationChange>Member</a>
            </li>
          }
          <li class="active">
            <a routerLink="/contact/contactus" skipLocationChange data-toggle="collapse" aria-expanded="false"><span (click)="goToContactUs()" (keyup.enter)="goToContactUs()" tabindex="0" role="button">Contact us</span></a>
          </li>
          @if (isUserLoggedIn || isAdminLoggedIn) {
            <li class="nav-item">
              <a class="nav-link"  routerLink="/"  skipLocationChange><span (click)="logout()" (keyup.enter)="logout()" tabindex="0" role="button">Logout</span></a>
            </li>
          }
        </ul>
      </nav>
    }
  </div>



